import type { FunnelStage } from './diagnostics'
import type { JoinErrorKind } from './types'

export function joinOutcomeFor(kind: JoinErrorKind): {
  stage: FunnelStage
  outcome: 'ok' | 'error'
  errorKind?: string
} {
  if (kind === 'switched') return { stage: 'left', outcome: 'ok', errorKind: 'moved_to_zoom' }
  return { stage: 'join_failed', outcome: 'error' }
}
